<template>
  <div class="hidden md:block max-w-[1500px] w-full mx-auto bg-slate-gray lg:rounded-[12px] overflow-hidden px-[16px] xs:px-[32px] lg:px-0 relative">
    <div class="container-lg mx-auto py-[64px] lg:py-[96px] z-20 relative">
      <div class="flex flex-col w-full md:w-1/2 lg:w-[40%] text-white">
        <h2 class="m-0 text-[40px] font-medium mb-3">
          {{ in18["page_subscribe_first"] }}
        </h2>
        <span class="text-[24px] leading-[32px] font-light mb-[32px]">
          {{ in18["page_subscribe_first_message"] }}
        </span>
        <div class="w-full flex flex-col md:flex-row gap-2 mb-4">
          <input
            @click="initRecaptcha"
            :disabled="inProgress"
            v-model="email"
            type="text"
            :placeholder="in18['page_subscribe_input_placeholder']"
            class="flex-1 px-4 py-[14px] rounded-[8px] text-charcoal outline-none placeholder:font-light placeholder:text-[16px] placeholder:leading-[20px] placeholder:text-[#9E9E9E]"
          />
          <button
            @click="fetchSubscriber()"
            :disabled="inProgress"
            type="button"
            class="px-[28px] py-[14px] bg-lime-green rounded-[8px] text-[16px] font-medium text-white hover:bg-lime-green-hover transition-all"
          >
            {{ in18["page_apply_label"] }}
          </button>
        </div>
        <span class="text-[11px] leading-[16px]" v-html="tos"></span>
        <google-recaptcha-v3
            id="subscribe_action"
            ref="captcha"
            v-model="gRecaptchaResponse"
            :site-key="captcha_site_key"
            action="subscribe_action"
            corner
        />
      </div>
    </div>
    <div class="hidden md:block right-0 top-0 bottom-0 w-[57%] absolute z-0">
      <div class="relative w-2/3 h-full bg-gradient-to-r from-slate-gray from-10% to-slate-gray/[0%] z-10 left-[-1px]"/>
      <img class="absolute w-full h-full top-0 right-0 object-cover z-0" src="/shop/images/subscribe_banner.webp" alt="">
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed, ref } from "vue";
import axios from 'axios'

const props = defineProps({
  in18: {
    type: Object,
    required: true,
  },
  captcha_site_key: {
    type: String,
  },
  action: {
    type: String,
  },
});

const email = ref('')
const inProgress = ref(false)
const gRecaptchaResponse = ref(null)
const recaptchaLoaded = ref(false)
const captcha = ref(null)

const tos = computed(() => {
  const link = `<a href="/privacy-policy" target="_blank" class="text-lime-green hover:underline">${props.in18["page_privacy_policy"]}</a>`;
  const string = props.in18["page_subscribe_tos"];

  return string.replace(/{link}/g, link);
});

function initRecaptcha() {
  if (!recaptchaLoaded.value) {
    captcha.value.init()
    recaptchaLoaded.value = true
  }
}
function fetchSubscriber() {
  if (inProgress.value) {
    return
  }

  inProgress.value = true

  const data = {
    email: email.value,
    gRecaptchaResponse: gRecaptchaResponse.value,
  }

  axios
    .post(props.action, data)
    .then((response) => {
      window.toastr.success(response.data.message)
    })
    .catch((error) => {
      window.toastr.error(error.response.data.message)
    })
    .finally(() => {
      email.value = ''
      inProgress.value = false
      captcha.value.execute()
    })
}

</script>
